import React from 'react';
import Spinner from '../../../common/Spinner';
import { LayoutGrid, LayoutGridCell } from '@cdk-uip/react-layout-grid';
import SideNav from '../../../solution-submission/common-sidenav-api/SideNavComponent/SideNav';
import LeftNavConfig from './left-nav-config';
import { injectIntl } from 'react-intl';
import SelectedPanel from './SelectedPanel';
import SolutionStatus from '../../../common/SolutionStatus';
import { withAuth } from '@cdk-prod/fortellis-auth-context';
import SolutionHeaderCommon from './SolutionHeaderCommon';
import moment from 'moment';
import FortellisConstants from '../../../common/FortellisConstants';
import UnauthorizedPage from '../../../common/UnauthorizedPage';
import NotFound from '../../../common/NotFound';
import PaymentInfoConstants from '../../../admin-account/solution-moderation/PaymentInfoConstants';
import navConstants from './left-nav-config-constants';
import { findIndex } from 'lodash';
import { connect } from 'react-redux';
import {
  Toast,
  TOAST_POSITIONS,
  TOAST_VISIBILITY_DURATIONS
} from 'cdk-radial';
import {
  getPaymentSetting,
  getAppPaymentHistory
} from '../../../../redux/connectedComponents/verifyAccount/verifyAccount.slice';
import { getStripeSubscriptionInfo } from '../../../../redux/connectedComponents/stripeSubscriptionInfo/stripeSubscriptionInfo.slice';
import { sendAmplitudeData } from '../../../../utils/amplitude';
import { AMPLITUDE_PROPERTIES } from '../../../../utils/amplitude-constants';
import styled from 'styled-components';

const StyledSaveToast = styled(Toast)`
  min-width: 572px;
  height: 108px;

  div {
    font-weight: 600;
  }
  button {
    margin-top: 40px;
  }  
`;

class SolutionManagement extends React.Component {
  constructor(props) {
    super(props);
    let menu = {
      ...JSON.parse(JSON.stringify(LeftNavConfig.MenuItems)),
      activeMenuId:
        this.props.history.location && this.props.history.location.state
          ? this.props.history.location.state.activeTab
          : LeftNavConfig.MenuItems.activeMenuId
    };
    let activeMenuId = 'manageListing';
    let activeMenuItem = {
      id: 'manageListing',
      label: 'Manage Listing Versions',
      type: 'simple'
    };
    if (this.props.solnTobePublished || this.props.otherPaymentOption) {
      activeMenuId = 'manageListing';
      menu = {
        ...JSON.parse(JSON.stringify(LeftNavConfig.MenuItems)),
        activeMenuId: 'manageListing'
      };
      activeMenuItem = {
        id: 'manageListing',
        label: 'Manage Listing Versions',
        type: 'simple'
      };
    }

    if (
      this.props.history.location &&
      this.props.history.location.state &&
      this.props.history.location.state.activeTab
    ) {
      activeMenuId = this.props.history.location.state.activeTab;
      activeMenuItem = {
        id: this.props.history.location.state.activeTab,
        label:
          this.props.history.location.state.activeTab.charAt(0).toUpperCase() +
          this.props.history.location.state.activeTab.slice(1),
        type: 'simple'
      };
    }

    menu = this.getMenuWithAppSettingsVisibility(menu, this.props.solutions);
    if (
      activeMenuId === 'appSettings' &&
      !this.isAppSettingsEnabled(this.props.solutions)
    ) {
      activeMenuId = 'manageListing';
      activeMenuItem = {
        id: 'manageListing',
        label: 'Manage Listing Versions',
        type: 'simple'
      };
      menu.activeMenuId = 'manageListing';
    }

    const routeActiveMenuId = this.props.match.params.activeMenuId;
    const isRouteDrivenMenu = ['appActivation', 'appSettings'].includes(
      routeActiveMenuId
    );
    const isAppSettingsRouteEnabled =
      routeActiveMenuId !== 'appSettings' ||
      this.isAppSettingsEnabled(this.props.solutions);
    const shouldUseRouteDrivenMenu =
      isRouteDrivenMenu && isAppSettingsRouteEnabled;

    this.state = {
      menu: !shouldUseRouteDrivenMenu
        ? menu
        : {
            ...menu,
            activeMenuId: routeActiveMenuId
          },
      activeMenuId: !shouldUseRouteDrivenMenu ? activeMenuId : routeActiveMenuId,
      activeMenuItem: !shouldUseRouteDrivenMenu
        ? activeMenuItem
        : {
            id: routeActiveMenuId,
            label: routeActiveMenuId === 'appSettings' ? 'App Settings' : 'App Activation',
            type: 'simple'
          },
      randomId: '',
      publishRequest: false,
      appSettingsSaveToast: null
    };
  }

  setAppSettingsSaveToast = toast => {
    this.setState({ appSettingsSaveToast: toast });
  };

  getMenuWithAppSettingsVisibility = (menu, solutions) => {
    if (!menu || !menu.contents || !menu.contents.length) {
      return menu;
    }

    const clonedMenu = JSON.parse(JSON.stringify(menu));
    const versionSection = clonedMenu.contents.find(
      item => item.title === 'Version and Insights'
    );

    if (!versionSection || !versionSection.steps) {
      return clonedMenu;
    }

    const appSettingsStep = {
      id: 'appSettings',
      label: 'App Settings',
      type: 'simple'
    };

    if (this.isAppSettingsEnabled(solutions)) {
      const hasAppSettings = versionSection.steps.some(
        step => step.id === 'appSettings'
      );
      if (!hasAppSettings) {
        versionSection.steps.push(appSettingsStep);
      }
      return clonedMenu;
    }

    versionSection.steps = versionSection.steps.filter(
      step => step.id !== 'appSettings'
    );

    if (clonedMenu.activeMenuId === 'appSettings') {
      clonedMenu.activeMenuId = 'manageListing';
    }

    return clonedMenu;
  };

  isAppSettingsEnabled = solutions => {
    if (!Array.isArray(solutions) || !solutions.length) {
      return false;
    }

    const latestSolution = [...solutions].sort(
      (a, b) =>
        parseInt(b.listingVersion || 0, 10) -
        parseInt(a.listingVersion || 0, 10)
    )[0];

    return (
      latestSolution &&
      [SolutionStatus.APPROVED, SolutionStatus.PUBLISHED].includes(
        latestSolution.status
      )
    );
  };

  handleOnApprovedAndOnlinePaymentModeSelected = () => {
    let currentMenu = this.state.menu;
    let resultArr = currentMenu.contents.filter(
      item => item.title === navConstants.REMITTANCE
    );
    if (resultArr.length === 0) {
      //add the remittance tab config in the menu.
      currentMenu.contents.push(navConstants.remittanceTabConfig);
      this.setState({ menu: currentMenu });
    }
  };

  componentDidUpdate(prevProps) {
    const paymentFlag =
      (!prevProps.solutions &&
        this.props.solutions &&
        this.props.solutions[0] &&
        !this.props.solutions[0].payment_info) ||
      (!prevProps.solutions &&
        this.props.solutions &&
        this.props.solutions[0] &&
        this.props.solutions[0].payment_info &&
        this.props.solutions[0].payment_info.paymentMode !==
          PaymentInfoConstants.paymentMode.ONLINE &&
        this.props.solutions[0].payment_info.paymentMode !==
          PaymentInfoConstants.paymentMode.OFFLINE_AND_ONLINE);

    let currentMenu = this.state.menu;
    let newMenu = { ...currentMenu };
    const shareSection = {
      id: 'share',
      label: 'Share',
      type: 'simple'
    };

    if (paymentFlag) {
      let remittanceTabIndex = currentMenu.contents.findIndex(
        item => item.title === navConstants.REMITTANCE
      );
      const newRemittanceSteps = currentMenu.contents[
        remittanceTabIndex
      ].steps.filter(item => item.label !== 'Accounts');
      currentMenu.contents[remittanceTabIndex].steps = newRemittanceSteps;
      newMenu.contents = currentMenu.contents;
    }

    let sharedSectionFlage = false;
    let publicSolution = false;
    let appSettingsMenuUpdated = false;
    if (this.props.solutions !== prevProps.solutions) {
      if (this.props.solutions && this.props.solutions.length > 0) {
        const publishedSolution = this.props.solutions.filter(
          solution => solution.status === 'Published'
        );
        if (publishedSolution && publishedSolution.length > 0) {
          const { solution_visibility } = publishedSolution[
            publishedSolution.length - 1
          ];
          if (solution_visibility) {
            const isVisible =
              solution_visibility.solutionVisibilityType === 'Private';
            if (isVisible) {
              sharedSectionFlage = true;
              if (newMenu.contents && newMenu.contents.length > 0) {
                if (newMenu['contents'][0]['steps']) {
                  const notAlreadyIncluded =
                    findIndex(this.state.menu['contents'][0]['steps'], {
                      id: 'share'
                    }) === -1;
                  if (notAlreadyIncluded) {
                    newMenu['contents'][0]['steps'].push(shareSection);
                  }
                }
              }
            } else {
              publicSolution =
                findIndex(this.state.menu['contents'][0]['steps'], {
                  id: 'share'
                }) >= 0;
              if (publicSolution) {
                newMenu['contents'][0]['steps'].pop();
              }
            }
          }
        }
      }

      const menuWithAppSettings = this.getMenuWithAppSettingsVisibility(
        newMenu,
        this.props.solutions
      );
      appSettingsMenuUpdated =
        JSON.stringify(menuWithAppSettings) !== JSON.stringify(newMenu);
      newMenu = menuWithAppSettings;
    }
    if (
      paymentFlag ||
      sharedSectionFlage ||
      publicSolution ||
      appSettingsMenuUpdated
    ) {
      this.setState({ menu: newMenu });

      if (
        this.state.activeMenuId === 'appSettings' &&
        !this.isAppSettingsEnabled(this.props.solutions)
      ) {
        this.setState({
          activeMenuId: 'manageListing',
          activeMenuItem: {
            id: 'manageListing',
            label: 'Manage Listing Versions',
            type: 'simple'
          }
        });
      }
    }
    if (this.props.otherPaymentOption !== prevProps.otherPaymentOption) {
      console.log('here we will trigger the event');
      this.changeMenu('manageListing');
    }
    if (
      !prevProps.solutions &&
      this.props.solutions &&
      this.props.solutions.length &&
      this.props.solutions[0].activateOnly !== false
    ) {
      this.props.getStripeSubscriptionData(
        this.props.solutions[0].id,
        this.props.solutions[0].orgId,
        this.props.auth.accessToken
      );
    }

    if (
      !prevProps.solutions &&
      this.props.solutions &&
      this.props.solutions.length &&
      this.props.solutions[0].id !== ''
    ) {
      this.props.getAppPaymentHistoryData(
        this.props.solutions[0].id,
        moment(this.props.solutions[0].registeredOn).format('ddd MMM DD YYYY'),
        moment()
          .add(1, 'day')
          .format('ddd MMM DD YYYY'),
        this.props.auth.accessToken
      );
    }

    if (
      prevProps.paymentHistoryData != this.props.paymentHistoryData &&
      this.props.paymentHistoryData &&
      this.props.paymentHistoryData.length === 0
    ) {
      let newContents = newMenu.contents.filter(
        tab => tab.title !== 'Remittance'
      );
      newMenu.contents = newContents;
      this.setState({
        menu: newMenu
      });
    }

    if (
      prevProps.paymentHistoryData != this.props.paymentHistoryData &&
      this.props.paymentHistoryData &&
      this.props.paymentHistoryData.length !== 0
    ) {
      let contentForRemittance = LeftNavConfig.MenuItems.contents.filter(
        section => section.title === 'Remittance'
      );
      if (!newMenu.contents.find(section => section.title === 'Remittance')) {
        const paymentFlag =
          (this.props.solutions &&
            this.props.solutions[0] &&
            !this.props.solutions[0].payment_info) ||
          (this.props.solutions &&
            this.props.solutions[0] &&
            this.props.solutions[0].payment_info &&
            this.props.solutions[0].payment_info.paymentMode !==
              PaymentInfoConstants.paymentMode.ONLINE &&
            this.props.solutions[0].payment_info.paymentMode !==
              PaymentInfoConstants.paymentMode.OFFLINE_AND_ONLINE);

        if (paymentFlag) {
          const newRemittanceSteps = contentForRemittance[0].steps.filter(
            item => item.label !== 'Accounts'
          );
          contentForRemittance[0].steps = newRemittanceSteps;
          newMenu.contents.push(...contentForRemittance);
        }
      }

      this.setState({
        menu: newMenu
      });
    }
  }

  handleMenuStateChange = newMenuState => {
    let menuNew = JSON.parse(JSON.stringify(newMenuState));
    this.setState({ menu: menuNew });
    let menuLabel;
    let activeMenuId = menuNew.activeMenuId;
    menuNew.contents.forEach(content => {
      content.steps.forEach(menuItem => {
        if (menuItem.id === activeMenuId) {
          menuLabel = menuItem.label;
          this.setState({
            activeMenuItem: menuItem,
            activeMenuId: activeMenuId
          });
        }
      });
    });
    const { entity, solutions } = this.props;
    sendAmplitudeData(menuLabel, {
      [AMPLITUDE_PROPERTIES.ORG_ID]: entity.id,
      [AMPLITUDE_PROPERTIES.ORG_NAME]: entity.name,
      [AMPLITUDE_PROPERTIES.APP_ID]: solutions[0].id,
      [AMPLITUDE_PROPERTIES.APP_NAME]: solutions[0].overview.name
    });
  };

  onEdit = async solution => {
    try {
      //run mutation to add a new solution listing version with status draft
      let solutionToCopy = { ...solution };
      solutionToCopy.status = SolutionStatus.DRAFT;
      solutionToCopy.registeredOn = moment().toISOString();
      delete solutionToCopy.appSettingsChangeHistory;

      await this.props.solutionListing.execute(solutionToCopy);

      await this.refetchData();
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  };

  onOperationComplete = async () => {
    await this.refetchData();
  };

  refetchData = async () => {
    await this.props.dataRefetch();
  };

  static async getDerivedStateFromProps(nextProps, prevState) {
    await nextProps.dataRefetch();
  }

  getOverallSolutionStatus = solutions => {
    if (solutions && solutions.length) {
      // 1. Sort solutions by listing version in descending order (latest first)
      const sortedSolutions = [...solutions].sort(
        (a, b) =>
          parseInt(b.listingVersion, 10) - parseInt(a.listingVersion, 10)
      );

      // If only one solution, return it
      if (sortedSolutions.length === 1) {
        return sortedSolutions[0];
      }

      // 2. Check if latest solution is published or withdrawn
      const latestSolution = sortedSolutions[0];
      if (
        latestSolution.status === SolutionStatus.PUBLISHED ||
        latestSolution.status === SolutionStatus.WITHDRAWN
      ) {
        return latestSolution;
      }

      // 3. Latest solution is not published/withdrawn, check previous version
      const previousSolution = sortedSolutions[1]; // Second in array after sorting

      // Check if previous version was recalled by system
      if (previousSolution.status === SolutionStatus.RECALLED) {
        const lastComment =
          previousSolution.comments && previousSolution.comments.length > 0
            ? previousSolution.comments[previousSolution.comments.length - 1]
            : null;

        if (
          lastComment &&
          lastComment.action === 'Recalled' &&
          lastComment.userId === 'System'
        ) {
          // Previous was system recalled, find last published or withdrawn solution
          // Compare listing versions and give priority to published version

          const publishedSolutions = sortedSolutions.filter(
            solution => solution.status === SolutionStatus.PUBLISHED
          );

          const withdrawnSolutions = sortedSolutions.filter(
            solution => solution.status === SolutionStatus.WITHDRAWN
          );

          // Get the most recent of each type (already sorted)
          const lastPublished =
            publishedSolutions.length > 0 ? publishedSolutions[0] : null;
          const lastWithdrawn =
            withdrawnSolutions.length > 0 ? withdrawnSolutions[0] : null;

          // Compare and give priority to published over withdrawn
          if (lastPublished && lastWithdrawn) {
            // Both exist, compare versions - prioritize published if versions are equal
            if (
              parseInt(lastPublished.listingVersion, 10) >=
              parseInt(lastWithdrawn.listingVersion, 10)
            ) {
              return lastPublished;
            }
            return lastWithdrawn;
          } else if (lastPublished) {
            return lastPublished;
          } else if (lastWithdrawn) {
            return lastWithdrawn;
          }

          // If no published or withdrawn found, return latest solution
          return latestSolution;
        }
      }

      // Previous was not system recalled, return previous solution
      return previousSolution;
    }
  };

  handleToggleChange = expandedMenuId => {
    this.setState({
      menu: Object.assign({}, this.state.menu, { expandedMenuId })
    });
  };

  changeMenu(activeMenuId) {
    if (!this.state.menu || !this.state.menu.contents) {
      return;
    }

    let filteredMenuItems = this.state.menu.contents
      .map(menuItem => {
        let filteredMenuItem = menuItem.steps.filter(step => {
          return step.id === activeMenuId;
        });
        return filteredMenuItem.length ? filteredMenuItem[0] : null;
      })
      .filter(item => item);
    if (!filteredMenuItems.length) {
      return;
    }
    let menu = JSON.parse(JSON.stringify(this.state.menu));
    menu.activeMenuId = activeMenuId;
    this.setState({
      activeMenuId: activeMenuId,
      activeMenuItem: filteredMenuItems[0],
      menu: menu
    });
  }

  refreshPendingAppActivations = () => {
    this.setState({ randomId: this.Id() });
  };
  componentDidMount() {
    this.props.getPaymentSettingData(
      this.props.auth.userData.email,
      this.props.entity.address.countryCode,
      this.props.auth.accessToken
    );
  }

  Id() {
    return Math.random()
      .toString(36)
      .substr(2, 9);
  }

  render() {
    const {
      loading,
      solutions,
      userPermissions,
      auth: { userData, accessToken },
      entity
    } = this.props;
    const { menu, activeMenuId, activeMenuItem } = this.state;
    if (
      userData &&
      solutions &&
      solutions.length &&
      solutions[0] &&
      solutions[0].orgId !== entity.id
    ) {
      return (
        <div className="solution-belongs-to-diff-entity-txt-container">
          <UnauthorizedPage />
        </div>
      );
    }

    if (
      solutions &&
      solutions.length &&
      solutions.slice(-1)[0].activateOnly !== false &&
      menu.contents[1].steps[2].label !== 'Activations'
    ) {
      let activationMenu = JSON.parse(JSON.stringify(this.state.menu));
      activationMenu.contents[1].steps[2].label = 'Activations';
      this.setState({
        menu: activationMenu
      });
    }
    return (
      <div className="component-content">
        {loading ? (
          <Spinner />
        ) : solutions && solutions.length > 0 ? (
          <LayoutGrid className="max-width-resp page-padding-common">
            <LayoutGridCell span={3} className="fm-side-nav">
              <SideNav
                sideNav={menu}
                handleToggleChange={this.handleToggleChange}
                handleSideNavStateChange={this.handleMenuStateChange}
              />
            </LayoutGridCell>
            <LayoutGridCell span={9}>
              <div>
                <SolutionHeaderCommon
                  solution={this.getOverallSolutionStatus(solutions)}
                  isSolutionReview={false}
                  isSolutionManagement={true}
                  refreshTriggerForPendingAppSubscriptions={this.state.randomId}
                  token={this.props.auth.accessToken}
                />
                {this.state.appSettingsSaveToast && (
                  <StyledSaveToast
                    content={this.state.appSettingsSaveToast.content}
                    id="app-settings-save-toast"
                    variant={this.state.appSettingsSaveToast.variant}
                    position={TOAST_POSITIONS.FIXED}
                    visibilityDuration={TOAST_VISIBILITY_DURATIONS.SIX_SECONDS}
                    onVisibilityDurationEnd={() =>
                      this.setAppSettingsSaveToast(null)
                    }
                    style={{ marginTop: '74px' }}
                    actions={[
                      {
                        onClick: () => this.setAppSettingsSaveToast(null),
                        text: 'Dismiss'
                      }
                    ]}
                  />
                )}
                {activeMenuId !== 'insights' && (
                  <div className="manage-solution-page-title">
                    {activeMenuItem.label ? activeMenuItem.label : false}
                  </div>
                )}
                {/* TODO - change this to show the correct status */}
                <div style={{ marginTop: '16px' }}>
                  <SelectedPanel
                    activeMenuId={activeMenuId}
                    activeMenuItem={activeMenuItem}
                    solutions={solutions}
                    submitSolution={this.props.submitSolution}
                    userPermissions={this.props.userPermissions}
                    remittanceInfo={this.props.remittanceInfo}
                    userData={userData}
                    onEdit={this.onEdit}
                    onOperationComplete={this.onOperationComplete}
                    entity={entity}
                    match={this.props.match}
                    history={this.props.history}
                    changeMenu={this.changeMenu.bind(this)}
                    accessToken={accessToken}
                    handleOnApprovedAndOnlinePaymentModeSelected={
                      this.handleOnApprovedAndOnlinePaymentModeSelected
                    }
                    handleSideNavStateChange={this.handleMenuStateChange}
                    refreshPendingAppActivations={
                      this.refreshPendingAppActivations
                    }
                    setSaveToast={this.setAppSettingsSaveToast}
                  />
                </div>
              </div>
            </LayoutGridCell>
          </LayoutGrid>
        ) : (
          <NotFound />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { data } = state.verifyAccount;
  return {
    solnTobePublished: data.verified,
    otherPaymentOption: data.otherPaymentOption,
    paymentHistoryData: data.paymentHistoryData
  };
};
const mapDispatchToProps = dispatch => ({
  getPaymentSettingData: (email, countryCode, token) =>
    dispatch(getPaymentSetting({ email: email, countryCode, token: token })),
  getStripeSubscriptionData: (solnId, orgId, token) => {
    dispatch(getStripeSubscriptionInfo({ id: solnId, orgId, token }));
  },
  getAppPaymentHistoryData: (solnId, startDate, endDate, token) => {
    dispatch(getAppPaymentHistory({ solnId, startDate, endDate, token }));
  }
});

SolutionManagement = injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SolutionManagement)
);

class SolutionManagementContainer extends React.Component {
  render() {
    return this.props.auth.isAuthenticated ? (
      <SolutionManagement {...this.props} />
    ) : (
      <></>
    );
  }
}
export default withAuth(SolutionManagementContainer);
